module.exports = __webpack_public_path__ + "resources/img/img_intro_certi5.13cc9c9fc1a3ebb482dddecf476f55aa.png";